export const chartConfig = {
  SET_BRUSH_MONITOR: 'CHART_CONFIG/SET_BRUSH_MONITOR',
};
